import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { DeleteScrapFinanceAccountsRequestModel, DeleteScrapFinanceAccountsResponseModel } from "@/features/accounts/scrap-finance/services/delete-accounts-model";

export class DeleteScrapFinanceAccountsApi {
  /**
   * 銀行口座削除API
   */
  public deleteScrapFinanceAccounts = async (
    param: DeleteScrapFinanceAccountsRequestModel
  ): Promise<DeleteScrapFinanceAccountsResponseModel> => {
    const path = `/api/scrapingaccounts/finances`;
    const res = await ApiClient.instance.delete<DeleteScrapFinanceAccountsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
